/* LP Gift-for-Women 1+1 quiz — self-contained fork of lp-quiz-women.js.
   Built 2026-09-20 from the approved map "השעון שלה: איך השאלון בוחר".
   One tree, one reader: a man buying a watch for his woman. Every question is
   about what he SEES on her every day, and the answer picks a watch that makes a
   set with the jewellery she already wears. Shares NO file with any live quiz. */
(function(){
window.__lpQuizV='gw-1.0';
try{console.log('[lp-quiz-gift-women] v'+window.__lpQuizV+' loaded')}catch(e){}

/* ═══ config — injected by sections/lp-quiz-women.liquid, editable in the theme editor ═══
   Every value falls back to the original hard-coded default, so a template that
   sets nothing behaves exactly like the GemPages original. */
const CFG=(function(){
  try{const el=document.querySelector('[data-lp-quiz-config]');return el?JSON.parse(el.textContent):{}}
  catch(e){return {}}
})();
/* which version of the quiz this is — stamped on every event, cart and order */
const VARIANT=CFG.variant||'v1';
try{window.__lpQuizVariant=VARIANT}catch(e){}

/* ═══ lead mode (v4, 2026-09-06) ═══
   v4 turns the quiz into a lead feeder: the terminal screens stop being a single
   "go to the store" button and offer a callback instead, and the objection
   answers that already routed to the form now pass through an explanation screen
   first. All three flags default OFF, so v1/v2/v3 behave exactly as before. */
const LEAD_MODE=CFG.lead_mode===true;
const LEAD_EMAIL=CFG.lead_email!==false;   /* v1-v3 keep the optional email field */
const END_CTA=CFG.end_cta_mode||'store_first';
/* ─── offer under test (2026-09-16) ──────────────────────────────────────────
   'mystery' = v1/v2/v3/v4 exactly as they have always run: the gift button adds
   the MysteryBox to the cart and every gift line promises it.
   'bxgy'    = the 1+1 only. No MysteryBox is ever added; the gift button walks
   the visitor into the collection where the automatic 1+1 applies.
   Anything but 'bxgy' reads as 'mystery', so a missing setting can never change
   the behaviour of v1/v2/v3. */
/* בפורק הזה ברירת המחדל הפוכה: השאלון הוא 1+1 בלבד. הגדרה ריקה או חסרה חייבת
   להישאר 1+1 ולא ליפול למתנה המסתורית, שגם לא רלוונטית לו וגם כתובה בלשון נקבה. */
const OFFER=CFG.offer==='mystery'?'mystery':'bxgy';
const BX=OFFER==='bxgy';
/* the mid-quiz popup fires after the 2nd screen and sells the MysteryBox, so it
   defaults OFF on a bxgy quiz. Either value of the setting overrides that. */
/* הפופאפ מוכר את המתנה המסתורית, ולכן כבוי כאן תמיד אלא אם מדליקים אותו במפורש */
const GIFT_POPUP=CFG.gift_popup===true;
/* where the gift button lands. v1-v3 have always gone to bestsellers. */
const RETURN_TO=CFG.collection_url||'/collections/bestsellers';
/* one label per offer, used by every end screen */
const GIFT_BTN=BX?'למעבר לאתר ולבחירת השעון השני מתנה':'לאיסוף המתנה ולבדיקה עם 30 יום';
const GIFT_BTN_HOLD=BX?'למעבר לאתר ולמימוש ההטבה':'לאיסוף המתנה ומעבר לרכישה עם 30 ימי ניסיון';
/* the screens that today end at GIFT and nothing else — the whole female tree
   plus the two hottest male screens. The three objection screens are not here:
   they carry their own close and their own button, built in render. */
const LEAD_SCREENS={gw_result:1};
/* v4 — nothing on an end screen offers the store any more, and no end screen
   offers a choice either: there is one button and it goes to the form. */
const A_SITE=`כן אהבתי, שלחו אותי לאתר`;                        /* v1-v3 only */
const A_REP=`אני עדיין לא בטוחה, אשמח שנציג יחזור אליי עם פרטים`;  /* v1-v3 only */

/* ═══ v4 — the end screens ═══
   Adam, 2026-09-06: on the last screen the objection answer is no longer the
   headline. The FIRST thing on the page is the belief — you choose a watch by
   talking to someone who knows watches — and the invitation that follows from
   it. The objection answer keeps its place, underneath. */
/* paragraphs, not pre-line: the source copy is written with blank lines between
   beats, and rendering those as whitespace is what made the screen feel airy and
   machine-made. Blank line becomes a paragraph, single break stays a break. */
const para=t=>(t||'').trim().split(/\n{2,}/).map(x=>`<p>${x.replace(/\n/g,'<br>')}</p>`).join('');
const fig=k=>`<img class="figimg${(k==='pressDuo'||k==='press13')?' figimg-press':''}" src="${IMG[k]}" alt="">`;
/* גלריית הביקורות — נגללת לצדדים, עם פתק של כל לקוחה מתחת לתמונה שלה.
   SOCIAL_PHOTOS יכול להיות מחרוזות (התנהגות ישנה) או {src,note,name}. */
const socialGrid=()=>`<div class="lp-social" role="group" aria-label="לקוחות עם השעון">${
  SOCIAL_PHOTOS.map(x=>{
    const o=(typeof x==='string')?{src:x}:(x||{});
    return `<figure class="lp-soc"><img src="${o.src}" alt="לקוחה עם שעון L&P" loading="lazy">${
      o.note?`<figcaption class="lp-soc-note">${o.note}${o.name?`<b>${o.name}</b>`:''}</figcaption>`:''}</figure>`;
  }).join('')}</div>`;

/* ═══ מסך התוצאה — הצצה מטושטשת ═══════════════════════════════════════════
   אדם, 2026-09-20: "תראה את השעון, מטושטש, מעל הכפתור, כדי שזה יפתח יותר
   סקרנות". אלה התמונות האמיתיות של שני הווריאנטים שנבחרו, מטושטשות. היא
   רואה שיש שם משהו קונקרטי שמחכה לה, בלי לראות מה. החשיפה בעמוד הקולקציה. */
const blurPeek=()=>{
  const pair=resultPair();
  if(!pair[0]||!pair[0].i) return '';
  return `<div class="lp-peek" aria-hidden="true">${
    pair.map((w,i)=>`<div class="lp-peek-card">
      <img src="${w.i}" alt="" loading="lazy">
      <span class="lp-peek-tag">${i?'והשני':'שלה'}</span>
    </div>`).join('')}
    <div class="lp-peek-veil"><span>שני השעונים שלה מחכים בקולקציה</span></div>
  </div>`;
};

/* ═══ v4 — the end screen ═══
   Adam, 2026-09-06. One card. The watchmaker IS the answer to the objection,
   so the old objection paragraph is gone entirely. The mould below is fixed and
   the ONLY thing that changes per objection is the opening line: what varies is
   which door the person came through, not what we offer them.

   What the mould has to make them feel, in this order:
     1. this is not standard — we do not do it for everyone
     2. we work with watchmakers, ten years each. That is a credential, not a job title
     3. the offer: we connect YOU to ours, about the watch YOU want
     4. he will tell you if it does not add up — that is what makes it not a sales call
     5. one question, one button                                                     */
/* the screens that get the end card — the six a person reaches by naming an
   objection. The result screens keep their model reveal and get the lead button. */
const END_OBJ={};   /* אין מסכי התנגדות בשאלון הזה — הוא עונה עליה, לא על עצמו */
const OBJ_OPEN={
  suspect_m:`אתה צודק שאתה חושד.`,
  suspect_f:`את צודקת שאת חושדת.`,
  price:`את השאלה הזאת כדאי לך לשאול שען, לא אותנו.`,
  unknown_brand:`מותג זה שם. ושם עולה כסף.`,
  spend:`אז אל תוציא שקל לפני שדיברת עם מישהו שמבין.`,
  no_clue:`אתה לא צריך להבין בשעונים.`,
  not_yet:``,                       /* no objection, just hasn't got round to it */
  overpay:`הדרך היחידה לדעת אם משהו שווה היא לשאול מי שיודע.`,
  style:`התאמה של שעון לבן אדם היא בדיוק המומחיות שלנו.`,
  photos:`מה אם שען אמיתי יתאר לך את השעון, ויגיד לך בדיוק מאילו חומרים הוא עשוי?`,
  returns:`הדרך הכי טובה להימנע מהחזרה היא לבחור נכון בפעם הראשונה.`,
  cheap:`אל תנחשי איך זה ייראה עליו.`,
  reviews:`הדרך הכי מהירה להכיר אותנו היא לדבר איתנו.`};
/* one objection earns the original answer before the handover: a person who does
   not believe in brands he has not heard of needs the logo-tax explained first,
   and only then the offer to check it with someone who is not us. */
/* which answer opened which door — matched on a distinctive fragment of the
   label, so the tree itself does not have to be restructured */
const OBJ_MATCH=[
  ['לא מבין בשעונים','no_clue'],['יותר מדי על משהו שלא שווה','overpay'],
  ['לא יתאים ללבוש','style'],['עוד לא הגעתי','not_yet'],
  ['לא יהיה כמו שהבטחתם','photos'],['נשמע לי טוב מדי','suspect'],
  ['לא יעלה במחיר כזה','price'],['מותגים שלא שמעתי','unknown_brand'],
  ['להוציא מאות שקלים','spend'],['להתעסק עם החזרות','returns'],
  ['ייראה עליו זול','cheap'],['מה אנשים אומרים','reviews']];
function noteObjection(label){
  const t=(label||'').replace(/\s+/g,' ');
  for(const [frag,key] of OBJ_MATCH) if(t.indexOf(frag)>-1){
    QUIZ.objKey=(key==='suspect')?(QUIZ.path==='gift'?'suspect_f':'suspect_m'):key; return;
  }
}

const OBJ_BRIDGE={
  unknown_brand:()=>[
    `שעון של ${G('20,000 שקל')} עולה ככה בגלל שלושה דברים: השם על הלוגו, הפרסומות, והרווח של כל מי שנוגע בו בדרך אליך.`,
    `החומרים עצמם? פלדת ${G('316L')}, מנגנון אמין וזכוכית ספיר. אנחנו מוכרים לך את אותם חומרים ישר, בלי השם ובלי המתווכים.`]};

/* the hinge. Adam, 2026-09-06: a paragraph has to hand over to the next one, or
   the block reads as separate statements stacked up. This is the sentence that
   carries the person from their own objection into the watchmaker. */
const OBJ_LINK={
  suspect_m:`אז אל תאמין לנו. תאמין לשען.`,
  suspect_f:`אז אל תאמיני לנו. תאמיני לשען.`,
  price:`אנחנו מוכרים, אז ברור מה נגיד. שען לא מוכר לך כלום.`,
  unknown_brand:`אבל אתה לא צריך להאמין לנו על זה. תאמין לשען.`,
  spend:`ומישהו שמבין זה לא נציג מכירות.`,
  no_clue:`בשביל זה יש שען.`,
  not_yet:`אז בוא נעשה לך את זה קל.`,
  overpay:`ומי שיודע זה לא אנחנו. זה השען.`,
  style:`וזה לא ניחוש. זו העבודה של שען.`,
  photos:`לא תמונה, ולא הבטחה שלנו. בן אדם שמחזיק את השעון ביד.`,
  returns:`והבחירה הנכונה מתחילה במישהו שיודע לבחור.`,
  cheap:`תשאלי מישהו שרואה את זה כל יום.`,
  reviews:`לא בביקורות. בשיחה.`};

/* Body order matters: the credential comes first, and the scarcity line FOLLOWS
   from it — their time is expensive, therefore this is not open to everyone —
   instead of being asserted cold at the top. */
const END_CARD=(f,k)=>{
  const key=OBJ_OPEN[k]!==undefined?k:(f?'suspect_f':'suspect_m');
  const open=OBJ_OPEN[key];
  const bridge=(OBJ_BRIDGE[key]?OBJ_BRIDGE[key]():[]).map(t=>`<p>${t}</p>`).join('');
  const link=OBJ_LINK[key]||'';
  return `<div class="endcard">
  ${open?`<div class="endcard-open">${open}</div>`:''}
  ${bridge}
  ${link?`<p class="endcard-link">${link}</p>`:''}
  <p>ב-L&amp;P אנחנו עובדים עם <b>שענים מקצועיים</b>. לכל אחד מהם <b>יותר מעשר שנות ניסיון</b>, והם יושבים מול השעונים האלה כל היום.</p>
  ${fig('workshop')}
  <p class="endcard-lead">בגלל שהזמן שלהם יקר, זה לא משהו שאנחנו פותחים לכל אחד. אבל ${f?'הגעת':'הגעת'} עד לפה, אז אנחנו רוצים <b>לחבר אותך לשען שלנו</b>.</p>
  <p>הוא יעבור איתך על השעון ש${f?'את מחפשת':'אתה רוצה'}, יגיד לך <b>מאיזה חומרים הוא עשוי</b>, ו<b>איזה דגם באמת מתאים ${f?'לו':'לך'}</b>.</p>
  <p class="endcard-honest">ואם משהו לא מסתדר, ${f?'תשמעי':'תשמע'} את זה ממנו. הוא לא מוכר, הוא מסביר.</p>
</div>`;};
const CLOSE_SUB=f=>`מה דעתך?`;
const CLOSE_BTN=`כן, שהשען יחזור אליי`;

function startQuiz(){
  track('QuizStart',{});
  logJourney('gate','start','q1');
  document.getElementById('landingPage').style.display='none';
  document.getElementById('quizApp').classList.add('active');
  window.scrollTo({top:0,behavior:'instant'});
  render('q1');
}
document.getElementById('startQuizBtn').addEventListener('click', startQuiz);

/* ═══ gate exits — the "skip the quiz, go to the store" clicks ═══
   Answers the open question: of the visitors who never start, who clicked
   through to the store vs. who bounced. Every <a> on the landing gate gets a
   beacon; navigation itself is native (not blocked), keepalive carries the
   row through in-app-browser navigations that unload the page. */
function exitLabel(href){
  var h=href||'';
  try{h=decodeURIComponent(h)}catch(e){}
  if(h.indexOf('mens-collection')>-1)return 'coll_men';
  if(h.indexOf('משובצ')>-1)return 'coll_diamond';
  if(h.indexOf('נשים')>-1)return 'coll_women';
  if(h.indexOf('bestsellers')>-1)return 'story_cta';
  return 'store_cta';
}
try{
  document.querySelectorAll('#landingPage a[href]').forEach(function(el){
    el.addEventListener('click',function(){
      var label=exitLabel(el.getAttribute('href'));
      try{track('QuizSkipToStore',{exit:label})}catch(e){}
      try{logJourney('gate','store_exit',label)}catch(e){}
    });
  });
}catch(e){}

const SITE=CFG.site||'https://lapoedagar.com';
/* lead form → Google Form → Google Sheet (filled by quiz_leads_setup.py) */
const LEAD=CFG.lead_form||{post:'https://docs.google.com/forms/d/e/1FAIpQLScr0dHwRCiJnnKEaB2dLWEc8UXyUHjVC-LAqmA2l_WccFS6DA/formResponse',name:'entry.199874719',phone:'entry.1778933271',email:'entry.1129508020',journey:'entry.1215223966'};

/* ═══ tracking — Meta fbq + TikTok ttq + Google gtag, all page-level ═══
   Shopify's channel pixels run in the web-pixels sandbox and can't see quiz
   clicks, so we load our own. NO PageView / ttq.page() here — the sandboxed
   pixels already send those; firing again = duplicate events. */
const PIXELS={meta:CFG.meta_pixel_id||'1639506919964880',tiktok:CFG.tiktok_pixel_id||'CJL66RBC77UEAFO1GRPG',google:CFG.google_ads_id||'AW-17548706483'};
/* Google Ads conversion actions (secondary — measurement only, no bidding impact) */
const GADS_CONV=CFG.gads_conv||{QuizComplete:'AW-17548706483/C0c0CNnw4dscELOF8K9B',QuizGiftClick:'AW-17548706483/_ZM6CNzw4dscELOF8K9B'};
try{
  if(!window.fbq){
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init',PIXELS.meta);
  }else{
    /* fbq is already on the page: the theme loads the SAME pixel id before this asset runs.
       Re-initialising an id Meta already has makes it log "Duplicate Pixel ID" and count
       PageView twice, which inflates the numbers a campaign optimises on. Only init when
       this pixel is genuinely absent. (QA 2026-09-06, F1) */
    try{
      var lpByID=window.fbq.instance&&window.fbq.instance.pixelsByID;
      if(lpByID&&!lpByID[PIXELS.meta])fbq('init',PIXELS.meta);
    }catch(e){}
  }
}catch(e){}
try{
  if(!window.ttq){
    !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
    ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
    ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
    for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
    ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};
    ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";var o=n&&n.partner;
    ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};
    var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src=r+"?sdkid="+e+"&lib="+t;
    var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(a,s)};
    ttq.load(PIXELS.tiktok);
    }(window,document,'ttq');
  }
}catch(e){}
try{
  if(!window.gtag){
    var gs=document.createElement('script');gs.async=true;
    gs.src='https://www.googletagmanager.com/gtag/js?id='+PIXELS.google;
    document.head.appendChild(gs);
    window.dataLayer=window.dataLayer||[];
    window.gtag=function(){dataLayer.push(arguments);};
    gtag('js',new Date());
  }
  gtag('config',PIXELS.google,{send_page_view:false});
}catch(e){}

/* which ad platform sent this person — ?src= override wins, else click IDs, else referrer */
function detectSrc(){
  try{
    const p=new URLSearchParams(location.search);
    if(p.get('src'))return p.get('src');
    if(p.has('fbclid'))return 'meta';
    if(p.has('ttclid'))return 'tiktok';
    if(p.has('gclid')||p.has('gbraid')||p.has('wbraid'))return 'google';
    if(p.get('utm_source'))return p.get('utm_source');
    const saved=sessionStorage.getItem('lp_quiz_src');if(saved)return saved;
    const r=document.referrer||'';
    if(/facebook\.|instagram\./.test(r))return 'meta';
    if(/tiktok\./.test(r))return 'tiktok';
    if(/google\.|youtube\./.test(r))return 'google';
    return 'direct';
  }catch(e){return 'direct'}
}
const QSRC=detectSrc();
try{sessionStorage.setItem('lp_quiz_src',QSRC)}catch(e){}
/* which campaign / ad brought this person — read from URL tags the campaigns append
   (Google: final_url_suffix ValueTrack; Meta/TikTok: url_tags on future uploads) */
function detectAd(){
  try{
    const p=new URLSearchParams(location.search);
    const parts=[];
    const camp=p.get('gcamp')||p.get('utm_campaign')||p.get('campaign_id')||'';
    const adset=p.get('gadset')||p.get('utm_medium_id')||p.get('adset_id')||'';
    const ad=p.get('gad')||p.get('utm_content')||p.get('ad_id')||'';
    if(camp)parts.push('c:'+camp);
    if(adset)parts.push('s:'+adset);
    if(ad)parts.push('a:'+ad);
    if(parts.length){const v=parts.join('|');sessionStorage.setItem('lp_quiz_ad',v);return v;}
    return sessionStorage.getItem('lp_quiz_ad')||'';
  }catch(e){return ''}
}
const QAD=detectAd();

const QUIZ={path:'gift',identity:'gift-for-her',objection:'',trail:[],ans:{}};
let curScreen='q1',quizCompleted=false;
/* short page codes for readable per-answer Meta event names */
const PAGE_CODE={gate:'GATE',q1:'Q1CLOTHES',q2:'Q2AGE',
  j1:'JW',j2:'JM1',j3:'JM2',o1:'OW',o2:'OM1',o3:'OM2',s1:'SW',s2:'SM1',s3:'SM2',
  w1:'WCOLOR',w2:'WPEARL',w3:'WW',w4:'WM1',w5:'WM2',w6:'WMC',w7:'WWC',skin:'SKIN',
  q_react:'QREACT',q_budget:'QBUDGET',c_value:'CVALUE',gw_proc:'PROC',gw_result:'RESULT',
  rep:'REP',rep_done:'REPDONE'};
/* short Hebrew question labels — used in the lead's journey summary for the rep */
const PAGE_HEB={q1:'מה היא לובשת',q2:'בת כמה היא',
  j1:'איזה שעון היא עונדת',o1:'איזה שעון היא עונדת',s1:'איזה שעון היא עונדת',
  w3:'איזה שעון היא עונדת',w7:'איזה שעון היא עונדת',
  j2:'צבע התכשיטים',j3:'צבע התכשיטים',o2:'צבע התכשיטים',o3:'צבע התכשיטים',
  s2:'צבע התכשיטים',s3:'צבע התכשיטים',w4:'צבע התכשיטים',w5:'צבע התכשיטים',w6:'צבע התכשיטים',
  w1:'צבע השמלות שלה',w2:'יש לה פנינים',skin:'גוון העור שלה',
  q_react:'מה שתרגיש כשהיא פותחת',q_budget:'התקציב שחשב עליו',c_value:'מסך הערך'};
const END_SCREENS={gw_result:1};

/* ═══ journey log — every step lands as a row in the LP Quiz Journeys form ═══
   Meta only shows aggregate counts; this gives us the exact per-session path
   (which screens, which answers, in order). Read back + analyzed by
   brands/la-poedega/tools/quiz_journeys_report.py */
const JOURNEY=CFG.journey_form||{post:'https://docs.google.com/forms/d/e/1FAIpQLSchZjFaOZtC1A2JbTm5K_TjMmmrC6N-Zs7T9LCzMndzzOTUIQ/formResponse',session:'entry.626601751',src:'entry.373322878',screen:'entry.1933156064',answer:'entry.1231347150',next:'entry.696230963',ad:'entry.1748222045'};
const SESSION_ID=(function(){
  try{
    let s=sessionStorage.getItem('lp_quiz_sid');
    if(!s){s=Math.random().toString(36).slice(2,10)+Date.now().toString(36);sessionStorage.setItem('lp_quiz_sid',s);}
    return s;
  }catch(e){return 'anon'+Math.floor(Math.random()*1e9)}
})();
function logJourney(screen,answer,next){
  try{
    const fd=new FormData();
    fd.append(JOURNEY.session,SESSION_ID);
    fd.append(JOURNEY.src,QSRC);
    fd.append(JOURNEY.screen,screen||'');
    fd.append(JOURNEY.answer,(answer||'').replace(/\s+/g,' ').trim().slice(0,120));
    fd.append(JOURNEY.next,next||'');
    fd.append(JOURNEY.ad,(QAD?QAD+'|':'')+'v:'+VARIANT);
    fetch(JOURNEY.post,{method:'POST',mode:'no-cors',body:fd,keepalive:true}).catch(()=>{});
  }catch(e){}
}

/* v4 — a lead campaign has to optimise on a STANDARD event. QuizLead was only
   ever a custom event, which Meta cannot bid on without a custom conversion
   built by hand, so it also goes out as the standard Lead / SubmitForm. The
   custom event stays alongside it: the existing audiences are built on it. */
const STD_EVENT={QuizLead:{meta:'Lead',tiktok:'SubmitForm'}};
function track(name,params){
  const p=Object.assign({},params||{});p.quiz_src=QSRC;p.quiz_variant=VARIANT;
  const std=STD_EVENT[name];
  try{if(window.fbq)fbq('trackCustom',name,p)}catch(e){}
  try{if(window.fbq&&std)fbq('track',std.meta,Object.assign({value:0,currency:'ILS'},p))}catch(e){}  /* Meta flags a Lead with no currency */
  try{if(window.ttq&&std)ttq.track(std.tiktok,p)}catch(e){}
  try{if(window.ttq)ttq.track(name,p)}catch(e){}
  try{if(window.gtag){gtag('event',name,p);
    if(GADS_CONV[name])gtag('event','conversion',{send_to:GADS_CONV[name]});}}catch(e){}
}
window.lpQuizTrack=track;   // gate-level events fired from the section, already variant-stamped
function modelName(){const c=CAT[RESULT];return c?c.n:(RESULT||'')}
function logAnswer(from,answerText,to){
  const a=(answerText||'').replace(/\s+/g,' ').trim().slice(0,95);
  QUIZ.trail.push((PAGE_HEB[from]||from)+': '+a);
  try{ (QUIZ.ans||(QUIZ.ans={}))[from]=ansIndex(from,answerText); }catch(e){}
  /* readable per-answer event for Meta: "FROM-TO answer" — the journey is visible
     straight from the event name in Events Manager */
  try{
    if(window.fbq){
      const evName=((PAGE_CODE[from]||from)+'-'+(PAGE_CODE[to]||to)+' '+a).slice(0,48);
      fbq('trackCustom',evName,{quiz_src:QSRC,path:QUIZ.path,quiz_variant:VARIANT});
    }
  }catch(e){}
  track('QuizAnswer',{step:from,answer:a,path:QUIZ.path});
}
/* logAnswer handles pixel routing; journey log gets EVERY answer uniformly */
const _origLogAnswer=logAnswer;
logAnswer=function(from,answerText,to){
  logJourney(from,answerText,to);
  _origLogAnswer(from,answerText,to);
};
/* answers → Shopify cart attributes → land on the order automatically */
function stampCart(){
  try{
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:{
        'Quiz source':QSRC,'Quiz path':QUIZ.path,'Quiz identity':QUIZ.identity,
        'Quiz objection':QUIZ.objection,'Quiz model':modelName(),'Quiz variant':VARIANT,
        'Quiz offer':OFFER,'Quiz pair':BX?pickPair().map(x=>x.n).join(' + '):''
      }})}).catch(()=>{});
  }catch(e){}
}
/* gift URL carries the same attributes — atomic backup in case the fetch never landed */
function giftUrl(){
  let u=GIFT_BASE_URL;
  try{
    const q=new URLSearchParams();
    q.set('attributes[Quiz source]',QSRC);q.set('attributes[Quiz path]',QUIZ.path);
    q.set('attributes[Quiz identity]',QUIZ.identity);q.set('attributes[Quiz objection]',QUIZ.objection);
    q.set('attributes[Quiz variant]',VARIANT);
    if(!BX) q.set('attributes[Quiz model]',modelName());
    if(BX){ const picks=pickPair();
      /* on bxgy "Quiz model" used to ride along as the default pickedModel, which is
         not what was served. The pair is the answer, so the pair is what the order says. */
      q.set('attributes[Quiz model]',picks.map(x=>x.n).join(' + '));
      q.set('attributes[Quiz pair]',picks.map(x=>x.n).join(' + '));
      if(picks[0]) q.set('dqh',picks[0].h);
      if(picks[1]) q.set('dqh2',picks[1].h);
      q.set('dqp',QUIZ.path==='gift'?'gift':'me'); }
    u=GIFT_BASE_URL+(GIFT_BASE_URL.indexOf('?')>-1?'&':'?')+q.toString();
  }catch(e){}
  return u;
}
/* ═══ bxgy — TWO watches, routed from the answers ═══════════════════════════
   Adam, 2026-09-16: "תבחר לו שני שעונים ולא אחד, לפי השאלון, ושהאופציה לא תהיה
   תמיד דובאי". The offer is 1+1, so the reveal names a PAIR.
   Every watch below is in `bestsellers` (so the reveal can find its card) AND in
   `קולקציית-גברים-copy` (so the 1+1 actually applies to it). Changing one means
   checking both memberships again. */
/* ═══ הקטלוג — קולקציית הנשים. handle + variant נמשכו חיים מ-Shopify ב-2026-09-17.
   שני שעונים לכל תוצאה: הראשון הוא מה שהיא תיארה, השני הוא החצי השני של ה-1+1.
   שניהם חייבים להיות בקולקציית נשים, כי שם חלה ההנחה האוטומטית. ═══ */
/* ═══ הקטלוג — ברמת הווריאנט, לא ברמת המוצר ═══════════════════════════════════
   נמשך חי מ-lapoedagar.com ב-2026-09-20 (products/<handle>.js). כל 14 המוצרים
   בקולקציית נשים, ולכן ההנחה האוטומטית "מבצע סוף שנה - 1+1" חלה על כולם.
   מפתח התוצאה הוא דגם+צבע, כי הצבע הוא כל הפואנטה של השאלון הזה: השעון צריך
   להיות סט אחד עם התכשיטים שהיא כבר עונדת. ═══ */
const CAT={
  'abigail'   :{k:'abigail', h:'la-poedagar™-abigail',        n:'L&P Abigail', c:'זהב, צמיד פנינים',        p:699.90, v:'45844786151615', i:'//cdn.shopify.com/s/files/1/0695/3192/6719/files/01_dd3aa123-6614-4440-a466-a065aa551e3b.jpg'},
  'talia'     :{k:'talia',   h:'la-poedagar™-talia',          n:'L&P Talia',   c:'זהב',                     p:549.90, v:'45844782547135', i:'//cdn.shopify.com/s/files/1/0695/3192/6719/files/01_4f77ca7b-deab-4e8d-8cbf-691e1092f303.jpg'},
  'lia'       :{k:'lia',     h:'la-poedagar™-lia',            n:'L&P Lia',     c:'זהב וכסף, אבנים סביב הלוח',p:449.90, v:'45844742176959', i:'//cdn.shopify.com/s/files/1/0695/3192/6719/files/01_c14135ff-f63b-4f9d-9927-cd99d2888b51.jpg'},
  'marina-g'  :{k:'marina',  h:'la-poedagar™-marina',         n:'L&P Marina',  c:'זהב מלא',                 p:499.90, v:'44538131120319', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/5_ecd8a5f1-8941-42db-bc0e-12900e22e77d.png'},
  'marina-s'  :{k:'marina',  h:'la-poedagar™-marina',         n:'L&P Marina',  c:'כסף',                     p:399.90, v:'44538131054783', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/7_e60e1cd2-6252-469b-92da-60670ad96749.png'},
  'eden-g'    :{k:'eden',    h:'la-poedagar™-eden',           n:'L&P Eden',    c:'זהב',                     p:499.90, v:'45844778582207', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_689fdc75-cf09-477c-88a0-fa127926eaa6.jpg'},
  'eden-s'    :{k:'eden',    h:'la-poedagar™-eden',           n:'L&P Eden',    c:'כסף',                     p:499.90, v:'45844778614975', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/06_4f4abdfc-801b-4ec6-9738-22a46a91370c.jpg'},
  'tamar-g'   :{k:'tamar',   h:'la-poedagar™-tamar',          n:'L&P Tamar',   c:'זהב',                     p:499.90, v:'45844772815039', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_1b63efdc-b5ed-4765-8ad7-75050c45bccc.jpg'},
  'tamar-s'   :{k:'tamar',   h:'la-poedagar™-tamar',          n:'L&P Tamar',   c:'כסף',                     p:499.90, v:'45844772847807', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/06_7cd0d2e1-0023-43d2-a794-603dd0c2a4df.jpg'},
  'daniela-g' :{k:'daniela', h:'la-poedagar™-daniela',        n:'L&P Daniela', c:'זהב מלא',                 p:399.90, v:'44539601387711', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/2_ad5041a9-fefc-4fbd-b078-6938816079a2.png'},
  'daniela-s' :{k:'daniela', h:'la-poedagar™-daniela',        n:'L&P Daniela', c:'כסף מלא',                 p:349.90, v:'44539601420479', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/3_243267c4-fdc3-4648-b1e3-4a69b5832f46.png'},
  'daniela-2' :{k:'daniela', h:'la-poedagar™-daniela',        n:'L&P Daniela', c:'זהב וכסף',                p:399.90, v:'44537063506111', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/1_b8e3c2f8-2f8c-4b0d-bdd1-4c3cb1a8a124.png'},
  'isabella-p':{k:'isabella',h:'la-poedagar™-isabella',       n:'L&P Isabella',c:'ורוד',                    p:349.90, v:'45844727857343', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01.jpg'},
  'isabella-b':{k:'isabella',h:'la-poedagar™-isabella',       n:'L&P Isabella',c:'תכלת',                    p:349.90, v:'45844727759039', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/18_a0399727-e23d-4a10-9f04-972d10a75e2b.jpg'},
  'isabella-s':{k:'isabella',h:'la-poedagar™-isabella',       n:'L&P Isabella',c:'כסף, לוח לבן',            p:349.90, v:'45844727824575', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/14_8eab12d1-1ff6-4f3d-b94e-19ed5be0e3d5.jpg'},
  'lola-g'    :{k:'lola',    h:'la-poedagar™-lola',           n:'L&P Lola',    c:'זהב',                     p:349.90, v:'45844760035519', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_0f086ec6-b165-44ec-9467-a2ce6a3f4558.jpg'},
  'lola-s'    :{k:'lola',    h:'la-poedagar™-lola',           n:'L&P Lola',    c:'כסף',                     p:349.90, v:'45844760068287', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/06_11175b4e-0598-4bd9-91a6-c7e5d99c3a79.jpg'},
  'shira-g'   :{k:'shira',   h:'la-poedagar™-shira',          n:'L&P Shira',   c:'זהב, לוח לבן',            p:319.90, v:'45844757250239', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_b7e10903-abb1-4de7-8ead-9627a4c8e127.jpg'},
  'shira-s'   :{k:'shira',   h:'la-poedagar™-shira',          n:'L&P Shira',   c:'כסף, לוח לבן',            p:319.90, v:'45844757283007', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/06_7bb2480f-fef9-4018-9bae-cc7de4449b24.jpg'},
  'noam'      :{k:'noam',    h:'la-poedagar™-noam',           n:'L&P Noam',    c:'זהב, לוח לבן',            p:319.90, v:'45844753547455', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_4b25bdb7-501f-4fa6-aeff-26aa88839910.jpg'},
  'adel'      :{k:'adel',    h:'la-poedagar™-adel',           n:'L&P Adel',    c:'זהב, לוח מרובע',          p:319.90, v:'45844737032383', i:'//cdn.shopify.com/s/files/1/0695/3192/6719/files/01_9fee35b9-0874-41e1-8a25-d6c9a3ec548e.jpg'},
  'neta-g'    :{k:'neta',    h:'la-poedagar™-noa',            n:'L&P Neta',    c:'זהב, לוח לבן',            p:299.90, v:'45844767211711', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_3ade8434-3edf-4241-842c-b00066a04b2b.jpg'},
  'neta-s'    :{k:'neta',    h:'la-poedagar™-noa',            n:'L&P Neta',    c:'כסף, לוח שחור',           p:299.90, v:'45844767244479', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/06_59b745ee-e511-48ba-9129-da091b095975.jpg'},
  'noa'       :{k:'noa',     h:'la-poedagar™-isabella-copy',  n:'L&P Noa',     c:'זהב וכסף',                p:299.90, v:'44536207835327', i:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/IMG_7371.webp'}
};
/* השעון השני של ה-1+1 — קרוב באופי, שונה במראה, ותמיד זול או שווה לראשון,
   כי ההנחה מאפסת את הזול מבין השניים. */
const PARTNER={
  abigail:'shira-g', talia:'neta-g', lia:'shira-s',
  'shira-g':'noam', 'shira-s':'neta-s',
  'marina-g':'shira-g', 'marina-s':'shira-s',
  adel:'neta-g',
  'daniela-g':'shira-g', 'daniela-s':'shira-s', 'daniela-2':'noa',
  noa:'shira-s',
  'isabella-p':'neta-s', 'isabella-b':'neta-s', 'isabella-s':'neta-s',
  'neta-g':'noam', 'neta-s':'noam', noam:'neta-s',
  'lola-g':'neta-g', 'lola-s':'neta-s',
  'eden-g':'lola-g', 'eden-s':'lola-s',
  'tamar-g':'lola-g', 'tamar-s':'lola-s'
};

/* ═══ מצב השאלון — מה שהתשובות שלו צברו בדרך ═══════════════════════════════
   nx  = המסלול שנפתח בשאלה 1 (ג׳ינס / שמלות / מכנסי בד / ספורט)
   m   = המתכת שהיא עונדת (g זהב / s כסף). "לא יודע" שולח לשאלת גוון העור.
   c   = משפחת הצבע של השמלות שלה (lola ורוד-סגול / eden כחול-ירוק / tamar צבעוני)
   after = לאן לחזור אחרי שאלת גוון העור, לפי המתכת שהיא תכריע   */
const ST={nx:'',m:'',c:'',after:null};
let RESULT='';                       /* מפתח התוצאה, למשל 'marina-g' */
const LANE_OF={j:'ג׳ינס',w:'שמלות',o:'מכנסי בד',s:'ספורט'};

/* טוקן ניווט: 'target!k=v!k=v'. היעד יכול להיות:
   מזהה מסך · '{nx}' · 'R:key' (עם {m}/{c} להחלפה) · 'SKIN:targetIfGold,targetIfSilver' */
function applyOps(raw){
  const parts=String(raw).split('!');
  for(let i=1;i<parts.length;i++){
    const kv=parts[i].split('='); if(kv.length<2) continue;
    if(kv[0]==='after'){ const t=kv[1].split(','); ST.after={g:t[0],s:t[1]}; }
    else ST[kv[0]]=kv[1];
  }
  return parts[0];
}
function expand(t){
  return String(t).replace('{nx}',ST.nx||'j1').replace('{m}',ST.m||'g').replace('{c}',ST.c||'lola');
}
/* מחזיר מזהה מסך אמיתי. תוצאה מסומנת ומנותבת למסכי החימום. */
function resolveGo(raw){
  let t=applyOps(raw);
  if(t.indexOf('SKIN:')===0){ const p=t.slice(5).split(','); ST.after={g:p[0],s:p[1]}; return 'skin'; }
  /* חוזרים משאלת גוון העור אל היעד שנשמר. לא מחזירים כאן: היעד הזה הוא בדרך כלל
     תוצאה (R:...), והוא חייב לעבור בבדיקת ה-R: שלמטה. */
  if(t==='AFTER_SKIN'){ const a=ST.after||{g:'j2',s:'j2'}; t=a[ST.m||'g']||a.g; }
  t=expand(t);
  if(t.indexOf('R:')===0){ RESULT=t.slice(2); return 'q_react'; }
  return t;
}
function resultPair(){
  const a=CAT[RESULT]||CAT['daniela-2'];
  const b=CAT[PARTNER[RESULT]]||CAT['neta-g'];
  return [a,b];
}
function pickPair(){ return resultPair(); }

/* איזו תשובה נבחרה בכל מסך — גם תמונות וגם טקסט. ממולא ב-logAnswer. */
function ansIndex(from,answerText){
  try{
    const S=SCREENS[from]||{};
    const list=(S.img||[]).concat(S.a||[]);
    const norm=t=>String(t).replace(/<[^>]*>/g,'').replace(/\s+/g,' ').trim();
    const want=norm(answerText);
    for(let i=0;i<list.length;i++){
      const li=norm(list[i][0]);
      if(li===want||want.indexOf(li.slice(0,38))===0) return i;
    }
  }catch(e){}
  return -1;
}
function pairKey(){ return RESULT||''; }
function priceShy(){ return false; }

/* bxgy — the result screen no longer shows the watch, the COLLECTION does.
   Hand the reveal everything it needs: which card to pull to the front, its name,
   which tree the visitor came down, and what they said on the way. */
function writeMatch(){
  if(!BX) return;
  try{
    const picks=pickPair();
    /* skip q1 ("for whom") and take the next three real answers. The TAIL of the
       trail is CTA clicks, not answers, which is what it used to quote. */
    const said=QUIZ.trail.slice(1,4).map(t=>String(t).split(': ').slice(1).join(': ').trim()).filter(Boolean);
    sessionStorage.setItem('lp_women_match',JSON.stringify({
      picks:picks.map(x=>({handle:x.h,name:x.n,price:x.p,vid:x.v})),
      /* handle/name stay filled for anything still reading the one-watch shape */
      handle:picks[0]?picks[0].h:'',name:picks[0]?picks[0].n:modelName(),
      path:QUIZ.path==='gift'?'gift':'me',said:said,offer:OFFER,route:pairKey()
    }));
  }catch(e){}
}
function trackGift(){
  writeMatch();
  track('QuizGiftClick',{path:QUIZ.path,identity:QUIZ.identity,objection:QUIZ.objection,model:modelName()});
  logJourney(curScreen,'GIFT_CLICK','cart');
  stampCart();
}
window.lpTrackGift=trackGift;
const IMG=Object.assign({
  /* ארבעת עוגני הסטייל — התמונות של בוחר הסטייל */
  vintageLife:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/07_f9f8ca91-c89e-4c17-931b-9e1b2de7fe07.jpg?v=1783937278',
  statementLife:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/3_d0c26728-03aa-49a7-9416-f3c57f727937.png?v=1757843170',
  classicLife:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/05_78db49bf-a8a5-496f-a437-563473532243.jpg?v=1783936977',
  gemsLife:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/07_b23af36d-e05f-41ff-9345-47d7b7abf938.jpg?v=1783937502',
  /* דגמים בודדים לשימוש חופשי בתוך מסכים */
  neta:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_3ade8434-3edf-4241-842c-b00066a04b2b.jpg?v=1783937423',
  adel:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_9fee35b9-0874-41e1-8a25-d6c9a3ec548e.jpg?v=1783936861',
  lia:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_c14135ff-f63b-4f9d-9927-cd99d2888b51.jpg?v=1783936977',
  abigail:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_dd3aa123-6614-4440-a466-a065aa551e3b.jpg?v=1783937695',
  /* נכסים משותפים — אותם קבצים שמשרתים את שאר השאלונים */
  press13:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/Screenshot_2025-12-16_at_23.39.38_0183ecc7-4a67-4862-b426-737cea1edef9.png?v=1779552574',
  pressDuo:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/smartravel_500_x_250_px_1.png?v=1774282907',
  proof:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/07_e01b006f-77c4-4067-aa1d-821143f800c6.jpg?v=1783937094',
  workshop:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/workshop-artisan.jpg?v=1779552540',
  offerbox:'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/05_bc5307c4-b0e4-4057-b7a5-2eb140c042fd.jpg?v=1783937642'
/* תמונות התשובות והשעונים מוזרקות מה-section כ-theme assets (lp-gw-*.jpg). */
}, (CFG.imgs||{}));
/* real Shopify product galleries — keyed by model, pulled live via Admin API */
/* גלריות מוצר אמיתיות מ-Shopify — משמשות את מסך התוצאה כשאין 1+1 */
const MODELS={
  shira:{name:'L&P Shira',price:'319.90',handle:'la-poedagar™-shira',gallery:[
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_b7e10903-abb1-4de7-8ead-9627a4c8e127.jpg?v=1783937278'
  ]},
  lia:{name:'L&P Lia',price:'449.90',handle:'la-poedagar™-lia',gallery:[
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_c14135ff-f63b-4f9d-9927-cd99d2888b51.jpg?v=1783936977'
  ]},
  talia:{name:'L&P Talia',price:'549.90',handle:'la-poedagar™-talia',gallery:[
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_4f77ca7b-deab-4e8d-8cbf-691e1092f303.jpg?v=1783937642'
  ]},
  marina:{name:'L&P Marina',price:'449.90',handle:'la-poedagar™-marina',gallery:[
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/6_e03f6e50-cb42-43da-a237-89474e15987e.png?v=1757711490'
  ]},
  daniela:{name:'L&P Daniela',price:'399.90',handle:'la-poedagar™-daniela',gallery:[
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/1_b8e3c2f8-2f8c-4b0d-bdd1-4c3cb1a8a124.png?v=1757658775'
  ]},
  tamar:{name:'L&P Tamar',price:'499.90',handle:'la-poedagar™-tamar',gallery:[
    'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/01_1b63efdc-b5ed-4765-8ad7-75050c45bccc.jpg?v=1783937502'
  ]}
};
/* מיפוי תמונת השאלה שנבחרה → איזה דגם היא מצביעה עליו */
/* #5 — customer photos for the social-proof screen (b_social).
   Drop Shopify CDN URLs in here; the grid renders only when it is non-empty,
   so an empty list shows nothing rather than a placeholder. */
/* הפתקים של הלקוחות — הקופי חי כאן, התמונות מגיעות מה-section.
   אלה הסדר: קפה עם חברה · פתיחת הקופסה · בית קפה · השולחן בבית. */
const SOCIAL_NOTES=[
  {note:'בעלי קנה לי אותו ליום ההולדת. כל פעם שאני יוצאת מישהי שואלת מאיפה הוא.', name:'נועה, 34'},
  {note:'פתחתי את הקופסה והייתי בהלם. לא האמנתי שזה המחיר.', name:'הדס, 29'},
  {note:'החברה שלי לא הפסיקה להסתכל עליו. אמרתי לה כמה הוא עלה והיא לא האמינה.', name:'שיר, 31'},
  {note:'אני עונדת אותו כל יום, גם לעבודה וגם בערב. הוא פשוט הולך עם הכל.', name:'רונית, 42'}
];
const SOCIAL_PHOTOS=((CFG.photos&&CFG.photos.length)?CFG.photos:[
  'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/06_7bb2480f-fef9-4018-9bae-cc7de4449b24.jpg?v=1783937278',
  'https://cdn.shopify.com/s/files/1/0695/3192/6719/files/07_63409300-0282-4e03-9eca-cc4ea480b029.jpg?v=1783937594'
]).map((u,i)=>Object.assign({src:u},SOCIAL_NOTES[i]||{}));
const IMG_TO_MODEL={vintageLife:'shira',statementLife:'marina',classicLife:'lia',gemsLife:'tamar'};
const IMG_TO_STYLE={vintageLife:'vintage',statementLife:'statement',classicLife:'classic',gemsLife:'gems'};
let pickedModel='lia', pickedStyle='classic';
function pickModel(k){ if(IMG_TO_MODEL[k]) pickedModel=IMG_TO_MODEL[k]; if(IMG_TO_STYLE[k]) pickedStyle=IMG_TO_STYLE[k]; }
const MYSTERY_VARIANT_ID=CFG.mystery_variant_id||45928714698943; /* L&P™ MysteryBox — ₪0, מוסתר מכל הקולקציות */
/* ניווט אמיתי (top-level) לעגלת האתר החי — עובד גם כשה-HTML הזה מוזרק כ-fragment בתוך GemPages */
const MYSTERY_ADD_URL=`${SITE}/cart/add?id=${MYSTERY_VARIANT_ID}&quantity=1&return_to=${RETURN_TO}`;
/* on bxgy there is nothing to add to the cart, so the button is a plain walk
   into the collection the 1+1 applies to. */
const GIFT_BASE_URL=BX?`${SITE}${RETURN_TO}?dq=1&dqo=bxgy`:MYSTERY_ADD_URL;
const G=n=>`<span class="gold">${n}</span>`;

/* ─── הקופי — נבנה מהזוויות של קמפיין WOMEN|14/09/25|ABO (36 קריאטיבים).
   קוצר ב-2026-09-17 לבקשת אדם: כל מסך נכנס למסך טלפון אחד, בלי גלילה. ─── */
/* ─── הקופי — כל השאלות הן על מה שהוא רואה עליה כל יום: מה היא לובשת, איזה
   שעון על היד שלה, ומה הצבע של התכשיטים שלה. הוא לא צריך לנחש כלום.
   מבנה העץ נעול מהמפה שאדם אישר (השעון שלה: איך השאלון בוחר, 2026-09-20). ─── */

/* שאלת המתכת — חוזרת בכל מסלול. "לא יודע" שולח לשאלת גוון העור ומשם חזרה. */
const METAL_Q=`מה הצבע של התכשיטים שהיא עונדת כל יום?`;
const M=(p,g,s,b)=>({p,step:'התכשיטים שלה',q:METAL_Q,
  /* "אני לא יודע" היא התשובה הרביעית ויושבת בריבוע הריק של השורה השנייה,
     ולא ככפתור טקסט מתחת לרשת. ארבעה ריבועים, רשת מלאה. */
  img:[['זהב',g+'!m=g','jw_gold'],
       ['כסף',s+'!m=s','jw_silver'],
       ['זהב וכסף ביחד',b+'!m=g','jw_mix'],
       ['אני לא יודע','SKIN:'+g+','+s,'jw_idk']]});

/* שאלת השעון שעל היד שלה — קובעת גודל לוח. אין בה "לא יודע" בכוונה:
   זה על היד שלה כל יום. */
const W=(p,small,big)=>({p,step:'השעון שעל היד שלה',q:`איזה שעון היא עונדת היום?`,
  img:[['שעון קטן ועדין',small,'w_small'],
       ['שעון גדול',big,'w_big'],
       ['שעון חכם',big,'w_smart'],
       ['היא לא עונדת שעון',small,'w_none']]});

const SCREENS={

q1:{p:6,step:'',q:`מה היא לובשת רוב הימים?`,
  img:[['ג׳ינס וטי-שירט','q2!nx=j1','jeans'],
       ['שמלות וחצאיות','q2!nx=w1','dress'],
       ['מכנסי בד וחולצה מכופתרת','q2!nx=o1','office'],
       ['טייץ ובגדי ספורט','q2!nx=s1','sport'],
       ['קצת מהכל','q2!nx=j1','mix']],
  trust:['משלוח מהיר','30 ימי ניסיון','13,336 לקוחות']},

q2:{p:16,step:'עליה',q:`בת כמה היא?`,
  a:[['עד 30','{nx}'],
     ['30 עד 40','{nx}'],
     ['40 עד 50','{nx}'],
     ['50 ומעלה','{nx}']]},

/* ══ מסלול ג׳ינס ══ */
j1:W(30,'j2','j3'),
j2:M(44,'R:neta-g','R:shira-s','R:noam'),
j3:M(44,'R:adel','R:isabella-s','R:daniela-2'),

/* ══ מסלול מכנסי בד ══ */
o1:W(30,'o2','o3'),
o2:M(44,'R:shira-g','R:shira-s','R:noa'),
o3:M(44,'R:daniela-g','R:daniela-s','R:daniela-2'),

/* ══ מסלול ספורט ══ */
s1:W(30,'s2','s3'),
s2:M(44,'R:neta-g','R:isabella-s','R:noa'),
s3:M(44,'R:adel','R:isabella-s','R:daniela-2'),

/* ══ מסלול שמלות — הצבע של השמלות קובע את צבע האבנים ══ */
w1:{p:26,step:'הבגדים שלה',q:`השמלות שלה בעיקר בצבע…`,
  img:[['שחור, לבן או בז׳','w2','dr_neutral'],
       ['ורוד וסגול','w7!c=lola','dr_pink'],
       ['כחול וירוק','w7!c=eden','dr_blue'],
       ['הרבה צבעים ופרחים','w7!c=tamar','dr_floral']],
  a:[['אני לא יודע','w2']]},

/* "כן" היה אמור להוציא את Abigail, שהצמיד שלה עשוי פנינים. הוא לא יכול:
   העלות שלה ₪125, מעל שער ה-₪80 של מאגרי ה-1+1, ולכן היא לא ב-BUYS ולא ב-GETS.
   הוכח על עגלה אמיתית ב-2026-09-20: Abigail + Shira = ₪1,019.80, כלום לא מתאפס.
   עד שאדם יכניס אותה למאגר ה-BUYS, "כן" מוציא את Talia, שהיא הזהב העדין
   שיושב יפה ליד פנינים, ושה-1+1 עליה עובד. */
w2:{p:33,step:'התכשיטים שלה',q:`יש לה שרשרת או עגילים עם פנינים?`,
  a:[['כן','R:talia'],['לא','w3'],['אני לא יודע','w3']]},

w3:W(38,'w4','w5'),
w4:M(48,'R:talia','R:shira-s','R:lia'),
w5:M(48,'R:marina-g','R:marina-s','R:lia'),
w7:W(38,'w6','w6'),
w6:M(48,'R:{c}-g','R:{c}-s','R:{c}-g'),

/* מופיעה רק כשהוא לא יודע אם היא עונדת זהב או כסף */
skin:{p:52,step:'שאלה אחת קטנה',q:`מה גוון העור שלה?`,
  sub:`זה עוזר לנו להחליט בשבילך בין זהב לכסף.`,
  img:[['בהיר','AFTER_SKIN!m=s','sk_light'],
       ['שזוף','AFTER_SKIN!m=g','sk_tan'],
       ['כהה','AFTER_SKIN!m=g','sk_dark']]},

/* ══ שני מסכי חימום — אחרי שהדגם כבר נבחר, לפני שמדברים על כסף ══ */
q_react:{p:64,step:'עליך',q:`מה אתה רוצה שהיא תרגיש כשהיא פותחת את המתנה?`,
  a:[['שהיא תהיה מבסוטה ממני','q_budget'],
     ['שהיא תחשוב שזה עלה אלפי שקלים','q_budget'],
     ['שהיא תרגיש שחשבתי עליה','q_budget'],
     ['שהיא תענוד אותו כל יום ולא תוריד','q_budget']]},

q_budget:{p:74,step:'עליך',q:`כמה חשבת להוציא על המתנה?`,
  a:[['עד 300 ₪','c_value'],
     ['300 עד 600 ₪','c_value'],
     ['600 עד 1,000 ₪','c_value'],
     ['עוד לא חשבתי','c_value']]},

c_value:{p:88,step:'רגע לפני התוצאה',
  h:`אז בוא נראה מה אתה מקבל על הכסף הזה.`,
  copy:`בתקציב שאתה מדבר עליו, אתה לא לוקח אחד. לחגים זה ${G('1+1')}: קונים שעון אחד, והשני מגיע במתנה.

השני יכול להיות שלה, או שלך. ואם זה לא מתאים לה, יש ${G('30 ימי ניסיון')}.`,
  social:true,
  sub:`רגע, מוצאים לה את הדגם.`,
  /* בלי טיימר כאן — הוא יושב על מסך התוצאה, ושתי הופעות מוציאות את הכפתור מהמסך */
  btn:['ממשיכים','gw_proc']},

gw_proc:{proc:true,next:'gw_result',
  msgs:['מנתחים את התשובות שלך...','מצליבים מול הקולקציה...','מאתרים את הדגם שלה...']},

/* stay: לא קופצים אוטומטית לקולקציה. המפה שאדם אישר מציגה מסך תוצאה, ורק
   הלחיצה עליו מעבירה לקולקציה. */
gw_result:{p:100,step:'סיימנו',stay:true,peek:true,
  h:`מצאנו לה שעון, ועוד אחד במתנה.`,
  copy:`לפי הבגדים שלה, הגיל, השעון שהיא עונדת היום והתכשיטים שלה.

בגלל שענית על השאלון יש לך ${G('1+1')}, אז בחרנו לה גם את השעון השני.
שניהם מחכים לך מסומנים בקולקציה.`,
  gift:true,
  timer:true,
  badges:['🛡️ אחריות שנתיים','🔄 30 ימי ניסיון','🚚 משלוח מהיר']},

/* טופס חזרה טלפונית — נשאר מהמנוע, נכנס לפעולה רק אם מדליקים lead_mode */
rep:{p:100,step:'',
  h:`תשאיר פרטים ונחזור אליך.`,
  copy:`נציג שלנו יעבור איתך על הדגם שיצא לה ועל ה-1+1.`,
  form:true},

rep_done:{p:100,step:'',
  h:`קיבלנו.`,
  copy:`נחזור אליך בהקדם.`,
  btn:['למעבר לאתר','GIFT']}
};

/* ─── countdown (24h, persists per browser) ─── */
function deadline(){
  let d=localStorage.getItem('lp_quiz_deadline');
  if(!d||+d<Date.now()){d=Date.now()+24*3600*1000;localStorage.setItem('lp_quiz_deadline',d);}
  return +d;
}
let tInt=null;
function startTimer(){
  clearInterval(tInt);
  const el=document.getElementById('tmr'); if(!el)return;
  const tick=()=>{
    let ms=deadline()-Date.now(); if(ms<0)ms=0;
    const h=String(Math.floor(ms/3600000)).padStart(2,'0'),
          m=String(Math.floor(ms%3600000/60000)).padStart(2,'0'),
          s=String(Math.floor(ms%60000/1000)).padStart(2,'0');
    el.textContent=`${h}:${m}:${s}`;
  };
  tick(); tInt=setInterval(tick,1000);
}

/* ─── engine ─── */
function go(id,ev){
  if(id==='SITE'){window.open(SITE,'_blank');return;}
  if(id==='GIFT'){trackGift();
    if(BX){location.href=giftUrl();} else {window.open(giftUrl(),'_blank');}
    return;}
  try{id=resolveGo(id)}catch(e){try{console.error('[lp-quiz-gift-women] resolveGo',id,e)}catch(_){}}
  const s=SCREENS[id]; if(!s)return;
  if(ev&&ev.currentTarget){
    try{logAnswer(curScreen,ev.currentTarget.textContent,id)}catch(e){}
    try{noteObjection(ev.currentTarget.textContent)}catch(e){try{console.error('[lp-quiz] noteObjection',e)}catch(_){}}
    ev.currentTarget.classList.add('picked');setTimeout(()=>render(id),160);return;
  }
  render(id);
}
window.go=go; window.pickModel=pickModel; window.submitLead=submitLead;
let backStack=[];
function goBack(){
  const prev=backStack.pop();
  if(prev) render(prev,true);
  const b=document.getElementById('lpBack');
  if(b) b.hidden=!backStack.length;
}
window.goBack=goBack;
function render(id,isBack){
  const s=SCREENS[id];
  clearInterval(tInt);
  /* #17 — a mis-tap used to be unrecoverable; keep a stack so it is not */
  if(!isBack && curScreen && curScreen!==id && !(SCREENS[curScreen]&&SCREENS[curScreen].proc)) backStack.push(curScreen);
  const backBtn=document.getElementById('lpBack');
  if(backBtn) backBtn.hidden=!backStack.length;
  curScreen=id;
  document.getElementById('stepc').textContent=s.step||'';
  if(s.proc){runProc(s);return;}
  document.getElementById('bar').style.width=(s.p||50)+'%';
  let h='';
  const _fem=QUIZ.path!=='gift';   /* נשים: עץ ה"לעצמי" הוא הנשי, עץ המתנה הוא הגברי */
  const _close=LEAD_MODE&&END_OBJ[id]?1:null;
  const _leadScreen=LEAD_MODE&&(END_OBJ[id]||LEAD_SCREENS[id]);
  /* v4 — the belief and the invitation come FIRST on an end screen. The answer
     to the objection follows underneath, where it supports rather than leads. */
  if(_close) h+=END_CARD(_fem,QUIZ.objKey);
  if(s.hero) h+=`<img class="hero" src="${IMG[s.hero]}" alt="">`;
  if(s.q) h+=`<h2>${s.q}</h2>`;
  if(_close){}
  else{
    if(s.h) h+=`<div class="copybox"><div class="headline">${s.h}</div>${s.copy||''}</div>`;
    else if(s.copy) h+=`<div class="copybox">${s.copy}</div>`;
    if(s.fig) h+=fig(s.fig);
    if(s.ph) h+=`<div class="ph">${s.ph}</div>`;
    if(s.social&&SOCIAL_PHOTOS.length) h+=socialGrid();
    if(s.copy2) h+=`<div class="copybox">${s.copy2}</div>`;
    if(s.fig2) h+=fig(s.fig2);
  }
  if(s.resultGallery&&!BX){
    const m=MODELS[pickedModel]||MODELS.lia;
    h+=`<div class="rgallery">
      <div class="rgallery-head"><div class="rgallery-name">${m.name}</div><div class="rgallery-price">₪${m.price}</div></div>
      <div class="rgallery-scroll">${m.gallery.map(u=>`<img src="${u}" alt="${m.name}" loading="lazy">`).join('')}</div>
    </div>`;
  }
  if(s.peek) h+=blurPeek();
  if(s.gift){
    /* v4 lead-only — the gift is the reason to give the number, so it stays on
       screen, but it stops being a door to the store. The rep brings it. */
    h+= (LEAD_MODE&&END_CTA==='lead_only')
      ? `<div class="giftcode">
      <div class="giftcode-t">🎁 ${BX?'ההטבה שלך שמורה: קונים שעון אחד, השני מתנה':'המתנה המסתורית שלך שמורה, בשווי ₪400 ומעלה'}</div>
      <div class="giftcode-note">${BX
        ?(_fem?'הנציג שלנו יסגור איתך את זה בשיחה, יחד עם הדגם שהתאמנו לו.'
              :'הנציג שלנו יסגור איתך את זה בשיחה, יחד עם הדגם שהתאמנו לך.')
        :(_fem?'הנציג שלנו יביא לך אותה בשיחה, יחד עם הדגם שהתאמנו לו.'
              :'הנציג שלנו יביא לך אותה בשיחה, יחד עם הדגם שהתאמנו לך.')}</div>
    </div>`
      : (BX
      ? `<div class="giftcode">
      <div class="giftcode-t">🎁 ההטבה שלך פעילה: קונים שעון אחד, השני מתנה</div>
      <a class="giftcode-btn" href="${giftUrl()}" onclick="lpTrackGift()">לראות את שני השעונים שלה, ${_fem?'לחצי':'לחץ'} כאן 👇</a>
      <div class="giftcode-note">הלחיצה מעבירה אותך לקולקציה, ושני השעונים שלה כבר מסומנים שם. מוסיפים אותם לעגלה, והזול מביניהם יורד לאפס בקופה, אוטומטית.</div>
    </div>`
      : `<div class="giftcode">
      <div class="giftcode-t">🎁 יש לך מתנה מסתורית מחכה, בשווי ₪400 ומעלה!</div>
      <a class="giftcode-btn" href="${giftUrl()}" target="_blank" rel="noopener" onclick="lpTrackGift()">לאיסוף המתנה המסתורית וכניסה לאתר, ${_fem?'לחצי':'לחץ'} כאן 👇</a>
      <div class="giftcode-note">הלחיצה פותחת את האתר שלנו בטאב חדש, ומוסיפה את השעון המסתורי ישר לעגלה שלך, בחינם.</div>
    </div>`);
  }
  /* v4 — on an objection screen the generic offer paragraph is replaced by the
     close written for THAT objection, and the branching answers are replaced by
     a single button. There is one thing to do here and it is the phone number. */
  if(s.offer&&!_close) h+=`<div class="offer">${s.offer}</div>`;
  if(s.timer&&!_leadScreen) h+=`<div class="timer">⏳ ההטבה נשמרת לך עוד <b id="tmr">24:00:00</b></div>`;
  if(s.sub||_close) h+=`<div class="qsub">${_close?CLOSE_SUB(_fem):s.sub}</div>`;
  if(s.img) h+=`<div class="imgopts">${s.img.map(([t,to,k])=>`<div class="imgopt" onclick="pickModel('${k}');go('${to}',event)"><img src="${IMG[k]}" alt="" loading="lazy"><div class="t">${t}</div></div>`).join('')}</div>`;
  if(_close) h+=`<button class="cta cta-lead cta-loud" onclick="go('rep')">${CLOSE_BTN}</button>`;
  else if(s.a) s.a.forEach(([t,to])=>{h+=`<button class="opt" onclick="go('${to}',event)">${t}</button>`;});
  if(s.form) h+=`<div class="copybox" style="padding:22px">
    <input id="lead_name" class="finput" type="text" placeholder="שם מלא" autocomplete="name">
    <input id="lead_phone" class="finput" type="tel" placeholder="מספר טלפון" autocomplete="tel" dir="rtl">
    ${LEAD_EMAIL?`<input id="lead_email" class="finput" type="email" placeholder="אימייל (לא חובה)" autocomplete="email" dir="rtl">`:''}
    ${LEAD_MODE?'':`<label class="lead-ok"><input type="checkbox" id="lead_consent"> מאשר שתחזרו אליי</label>`}
    <div id="lead_err" style="color:#c0392b;font-size:13.5px;min-height:18px;margin-top:2px"></div>
    <button class="cta" onclick="submitLead()">${LEAD_MODE?'שלחו את הפרטים לשען':'שלחו לי פרטים'}</button>
    ${LEAD_MODE?`<div class="leadnote">השיחות נקבעות לפי התור. משאירים פרטים פעם אחת, ואנחנו חוזרים.</div>`:''}</div>`;
  /* v4 — a terminal screen that used to offer only "go to the store" now offers
     the callback instead. Every lead button goes straight to the form: an extra
     explanation screen in between just said the same thing twice. */
  const _isEnd=LEAD_MODE&&(LEAD_SCREENS[id]||_close);   /* any v4 end screen */
  const _only=_isEnd&&END_CTA==='lead_only';
  /* the close already printed its own button, so only the screens without one
     get a lead button here */
  const leadBtn=(_isEnd&&!_close)
    ? `<button class="cta cta-lead${(END_CTA==='lead_first'||_only)?' cta-loud':''}" onclick="go('rep')">${CLOSE_BTN}</button>` : '';
  /* lead_only removes the exit to the store entirely. Adam, 2026-09-06: on the
     end screens of the lead variant there is no such option, not as a button and
     not as a link. The phone number is the only way out. */
  const mainBtn=(!s.btn||_only) ? ''
    : `<button class="cta${(leadBtn&&END_CTA==='lead_first')?' cta-sec':''}" onclick="go('${s.btn[1]}')">${s.btn[0]}</button>`;
  h += (END_CTA==='lead_first'||_only) ? (leadBtn+mainBtn) : (mainBtn+leadBtn);
  if(s.badges) h+=`<div class="badges">${s.badges.map(b=>`<span>${b}</span>`).join('')}</div>`;
  if(s.trust) h+=`<div class="trust">${s.trust.map(t=>`<span>${t}</span>`).join('')}</div>`;
  const _m=MODELS[pickedModel]||MODELS.lia;
  h=h.replace(/%%MODEL_NAME%%/g,_m.name).replace(/%%MODEL_PRICE%%/g,_m.price);
  swap(h);
  /* In lead mode the journey ends one screen earlier: the objection screen IS
     the last screen, because that is where the phone form is asked for instead
     of routing on to a_result. a_screen3 & friends are in END_OBJ but not in
     END_SCREENS, so QuizComplete could never fire on v4 and "LP Quiz - Complete"
     read 0 no matter how well it did (v4: 10 answered a question, 0 completes;
     v2 on the same days: 386 answered, 344 completes). Counting END_OBJ as an
     end screen ONLY when LEAD_MODE is on keeps v1/v2/v3 semantics untouched, so
     their history stays comparable. */
  if((END_SCREENS[id]||(LEAD_MODE&&END_OBJ[id]))&&!quizCompleted){
    quizCompleted=true;
    track('QuizComplete',{end_screen:id,path:QUIZ.path,identity:QUIZ.identity,objection:QUIZ.objection,model:modelName()});
    logJourney(id,'COMPLETE|'+modelName(),'');
    stampCart();
    writeMatch();
  }
  if(s.timer&&!_leadScreen) startTimer();
  if(screensSeen++>=2) maybeShowGiftPopup();
}
let giftShown=false, screensSeen=0;
function maybeShowGiftPopup(){
  if(!GIFT_POPUP) return;
  if(giftShown) return;
  giftShown=true;
  /* בשאלון הנשים עץ ה"לעצמי" הוא הנשי, ועץ המתנה הוא הגברי */
  const f = QUIZ.path!=='gift';
  const line = f
    ? 'סיימי את השאלון וקבלי מתנה מסתורית בשווי ₪400 ומעלה, בנוסף לשעון שתבחרי.'
    : 'סיים את השאלון וקבל מתנה מסתורית בשווי ₪400 ומעלה, בנוסף לשעון שתבחר.';
  setTimeout(()=>{
    const ov=document.createElement('div');
    ov.className='lpgift-ov';
    ov.innerHTML=`<div class="lpgift-card">
      <div class="lpgift-icon">🎁</div>
      <div class="lpgift-h">מחכה לך מתנה!</div>
      <div class="lpgift-p">${line}</div>
      <button type="button" class="lpgift-btn">${f?'בואי נמשיך':'בוא נמשיך'}</button>
    </div>`;
    const close=()=>ov.remove();
    ov.querySelector('.lpgift-btn').addEventListener('click',close);
    ov.addEventListener('click',e=>{ if(e.target===ov) close(); });      /* #14 backdrop */
    document.addEventListener('keydown',function esc(e){
      if(e.key==='Escape'){ close(); document.removeEventListener('keydown',esc); }
    });
    document.body.appendChild(ov);
  },150);
}
function runProc(s){
  document.getElementById('bar').style.width='94%';
  swap(`<div class="proc"><div class="spinner"></div><div class="procmsg" id="pm">${s.msgs[0]}</div><div class="procbar"><i id="pb"></i></div></div>`);
  let i=0;
  const step=()=>{
    document.getElementById('pb').style.width=((i+1)/s.msgs.length*100)+'%';
    document.getElementById('pm').textContent=s.msgs[i];
    i++;
    if(i<s.msgs.length) setTimeout(step,900);
    else if(BX&&END_SCREENS[s.next]&&!(SCREENS[s.next]||{}).stay) setTimeout(()=>finishToCollection(s.next),700);
    else setTimeout(()=>render(s.next),900);
  };
  step();
}
/* bxgy — Adam, 2026-09-16: "אחרי שאני עונה על הכל זה שולח ל-bestsellers ומדגיש לי
   את השעון שנבחר". So the result screen is never rendered on a bxgy quiz. Everything
   it used to fire has to fire here instead, or QuizComplete goes to zero. */
function finishToCollection(endId){
  try{
    if(!quizCompleted){
      quizCompleted=true;
      track('QuizComplete',{end_screen:endId,path:QUIZ.path,identity:QUIZ.identity,
                            objection:QUIZ.objection,model:modelName()});
      logJourney(endId,'COMPLETE|'+modelName(),'');
    }
    trackGift();            /* writeMatch + QuizGiftClick + journey + cart attributes */
  }catch(e){}
  /* the attributes ride on the URL too, so a cancelled /cart/update cannot lose them */
  setTimeout(()=>{ try{location.href=giftUrl();}catch(e){} },450);
}
function submitLead(){
  const name=document.getElementById('lead_name').value.trim();
  const phone=document.getElementById('lead_phone').value.trim();
  const emailEl=document.getElementById('lead_email');
  const email=emailEl?emailEl.value.trim():'';
  const err=document.getElementById('lead_err');
  if(!name){err.textContent='רגע, חסר שם';return;}
  if(!/^0\d{1,2}-?\d{7}$/.test(phone.replace(/[\s-]/g,''))&&!/^\+?\d{9,13}$/.test(phone.replace(/[\s-]/g,''))){err.textContent='מספר הטלפון לא נראה תקין';return;}
  if(email&&!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){err.textContent='האימייל לא נראה תקין';return;}
  const consent=document.getElementById('lead_consent');
  if(consent&&!consent.checked){err.textContent='צריך לאשר שנחזור אליך';return;}   /* v1-v3 only */
  err.textContent='';
  if(LEAD.post&&LEAD.post.indexOf('__')!==0){
    const fd=new FormData();
    fd.append(LEAD.name,name);
    fd.append(LEAD.phone,phone);
    if(LEAD.email)fd.append(LEAD.email,email);
    /* full quiz journey rides with the lead — the rep sees exactly what stopped
       this person and what they want, before picking up the phone */
    if(LEAD.journey){
      /* QAD carries c:<campaign>|s:<adset>|a:<ad> from the ad's url_tags — the leads
         sheet resolves those ids to names, so we know which AD SET produced the lead
         and not just "meta". Only rides along when the URL actually carried tags. */
      const head=['שאלון: '+VARIANT,'מקור: '+QSRC];
      if(QAD)head.push('תיוג מודעה: '+QAD);
      const j=head.concat(['מסלול: '+(QUIZ.path==='gift'?'מתנה לבן זוג':'לעצמו'),
               'דגם שהותאם: '+modelName()]).concat(QUIZ.trail).join('\n');
      fd.append(LEAD.journey,j.slice(0,2500));
    }
    /* #6 — a failed send used to be swallowed and the thank-you shown anyway.
       no-cors gives an opaque response, so a network failure is all we can see;
       when it happens, keep the user on the form so the number is not lost. */
    fetch(LEAD.post,{method:'POST',mode:'no-cors',body:fd})
      .then(()=>finishLead())
      .catch(()=>{ err.textContent='השליחה לא עברה. יש חיבור לאינטרנט? נסה שוב.'; });
    return;
  }
  finishLead();
}
function finishLead(){
  track('QuizLead',{path:QUIZ.path});
  logJourney('rep','LEAD','rep_done');
  stampCart();                    /* #13 — a lead now carries the variant too */
  go('rep_done');
}
function swap(h){
  const st=document.getElementById('stage');
  st.style.animation='none'; void st.offsetWidth; st.style.animation='';
  st.innerHTML=h;
  window.scrollTo({top:0,behavior:'smooth'});
}

track('QuizView',{});
logJourney('gate','view','');

})();

/* ═══ mystery-gift cart limiter (was a second GemPages block) ═══ */
/* מגבלת מתנה — תמיד בדיוק שעון מתנה אחד בעגלה */
(function(){
  var V=45928714698943;
  var ADD='/cart/add?id='+V+'&quantity=1';
  var UPD='/cart/update?updates['+V+']=1';
  function fix(u){ return (u||'').split(ADD).join(UPD); }

  document.addEventListener('click',function(e){
    try{
      var t=e.target;
      var a=(t&&t.closest)?t.closest('a[href*="cart/add?id='+V+'"]'):null;
      if(a) a.setAttribute('href',fix(a.getAttribute('href')));
    }catch(err){}
  },true);

  var origGo=window.go;
  if(typeof origGo==='function'){
    window.go=function(id,ev){
      if(id!=='GIFT') return origGo(id,ev);
      var origOpen=window.open;
      window.open=function(u,t,f){ return origOpen.call(window,fix(u),t,f); };
      try{ return origGo(id,ev); } finally { window.open=origOpen; }
    };
  }
})();
